import {FloatingUnitField} from "@mytour/ui/form";
import type {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import type {Step3ShiftingPriceForm} from "../Step3ShiftingPrice";

type Props = {
  hookForm: UseFormReturn<Step3ShiftingPriceForm>;
  disabled: boolean;
};

export function RealSetup({hookForm, disabled}: Props) {
  const {t: translate} = useTranslation();
  return (
    <FloatingUnitField<Step3ShiftingPriceForm>
      name="shiftingAmount"
      label={translate("myTourApp.platformUser.shiftingAmount")}
      suffix="€/km"
      control={hookForm.control}
      disabled={disabled}
      required
      error={hookForm.formState.errors.shiftingAmount}
    />
  );
}
